module.exports = __webpack_public_path__ + "static/media/profile.a3a5875c.svg";